import React, { Component } from "react";
import { BasicMapStyle } from "../../helpers/mapstylejson";
import { SelectBox } from "devextreme-react/select-box";
import { LoadPanel } from "devextreme-react/load-panel";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";
import { DateFormat } from "../../helpers/fixcodes";
import moment from "moment";
import { List } from "devextreme-react";
import DataSource from "devextreme/data/data_source.js";
var MarkerWithLabel = require("markerwithlabel")(window.google.maps);
export class TrackingComponent extends Component {
  static displayName = TrackingComponent.name;
  constructor(props) {
    super(props);
    let transporterId = 0;
    let airportCode = "";
    let sourceUrl = "";
    if (this.props.location.state) {
      transporterId = this.props.location?.state?.transporterId ?? 0;
      airportCode = this.props.location?.state?.airportCode ?? "";
      sourceUrl = this.props.location?.state?.sourceUrl ?? "";
    }

    this.state = {
      loadPanelVisible: false,
      isSearch: false,
      airportDropdownDataSource: [],
      airportCode: airportCode,
      transporterDropdownDataSource: [],
      transporterId: transporterId,
      trackingLst: [],
      sourceUrl: sourceUrl,
      map: {
        center: { lat: 19.0936, lng: 72.856629 },
        zoom: 10,
      },
      radius: 500,
      intervalSecond: 5,
    };
    this.isComponentDidMounted = false;
    this.allowAutoRefresh = false;
    this.mapRef = React.createRef();
    this.map = null;
    this.vehicleMarkers = [];
    this.trackingRefreshInterval = null;
  }
  componentDidMount() {
    try {
      if (this.isComponentDidMounted) {
        return;
      }
      this.map = new window.google.maps.Map(this.mapRef.current, {
        center: this.state.map.center,
        zoom: this.state.map.zoom,
        styles: BasicMapStyle,
        gestureHandling: "cooperative",
        options: {
          gestureHandling: "greedy",
          panControl: true,
          zoomControl: true,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: true,
          overviewMapControl: true,
          rotateControl: true,
        },
      });
      this.fetchDataOnPageLoad();
      this.isComponentDidMounted = true;
    } catch (error) {
      console.log(error);
    }
  }
  fetchDataOnPageLoad = () => {
    try {
      setTimeout(async () => {
        await this.getAirportDropdown();
      }, 0);
      setTimeout(async () => {
        await this.getServiceProviderDropdown();
      }, 0);
      if (this.state.transporterId > 0 || !this.state.airportCode) {
        setTimeout(async () => {
          await this.getTrackingData(
            this.state.transporterId,
            this.state.airportCode
          );
        }, 0);
      }
    } catch (error) {
      console.log(error);
    }
  };
  getAirportDropdown = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      const response = await axiosGet(
        `Airport/get-airport-dropdown/${airlineCode}`
      );
      this.setState((prev) => ({
        ...prev,
        airportDropdownDataSource: response.payload ?? [],
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getAirportDropdown function",
        err
      );
    }
  };
  getServiceProviderDropdown = async () => {
    try {
      const response = await axiosGet("Account/get-transport-dropdown");
      this.setState((prev) => ({
        ...prev,
        transporterDropdownDataSource: response.payload ?? [],
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getServiceProviderDropdown function",
        err
      );
    }
  };
  getTrackingData = async (transporterId, airportCode) => {
    try {
      clearInterval(this.trackingRefreshInterval);
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      const response = await axiosPost("Tracking", {
        AirlineCode: airlineCode,
        TransporterId: transporterId,
        AirportCode: airportCode,
        RideId: 0,
      });
      const data = response.payload ?? [];
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
        trackingLst: data,
      }));
      setTimeout(() => {
        this.drawVehicleMarkers();
      }, 1000);
      if (this.allowAutoRefresh === true) {
        this.trackingRefreshInterval = setInterval(async () => {
          await this.getTrackingData(
            this.state.transporterId,
            this.state.airportCode
          );
        }, this.state.intervalSecond * 1000);
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getTrackingData function",
        err
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };
  setZoom = (lat, lng, radius) => {
    try {
      let zoomlevel = this.getZoomLevel(radius);
      let latlng = { lat: Number(lat), lng: Number(lng) };
      let bounds = new window.google.maps.LatLngBounds();
      bounds.extend(latlng);
      this.map.setZoom(zoomlevel);
      this.map.panTo(latlng);
      this.map.fitBounds(bounds);
    } catch (error) {
      console.log(error);
    }
  };
  getZoomLevel = (radius) => {
    let zoomLevel = 17;
    let scale = radius / 500;
    zoomLevel = 16 - Math.log(scale) / Math.log(2);
    return zoomLevel;
  };
  getDatetimeForamted(value) {
    value = value
      ? moment(value).format(DateFormat.MomentDisplayDateTimeAMPMFullFormat)
      : "";
    return value;
  }
  drawVehicleMarkers = () => {
    try {
      this.clrearVehicleMarker();
      let bounds = new window.google.maps.LatLngBounds();
      this.state.trackingLst.map((vehicle) => {
        if (vehicle.vehicleLatitude > 0 && vehicle.vehicleLongitude > 0) {
          let latLng = new window.google.maps.LatLng(
            vehicle.vehicleLatitude,
            vehicle.vehicleLongitude
          );

          let iconImage = {
            url: this.getMarkerIconUrl(vehicle.hostStatus, vehicle.course), //"../assets/img/device-icons/Car/Car_blue_25.png",
            size: new window.google.maps.Size(30, 30),
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(15, 15),
          };

          const infoContents = this.setMarkerInfoContent(vehicle);
          const lableContents = this.setMarkerLableContent(vehicle);

          let marker = new MarkerWithLabel({
            position: latLng,
            map: this.map,
            draggable: false,
            icon: iconImage,
            zIndex: 201,
            labelContent: lableContents,
            labelStyle: {
              backgroundColor: "#eaf5fd",
              border: "1px solid #cecece",
              borderRadius: "8px",
              padding: "2px 10px 2px 10px",
              fontSize: "11px",
              fontWeight: "bold",
              fontFamily: "Segoe UI",
              color: "#095590",
            },
            labelAnchor: new window.google.maps.Point(20, 75),
            text: vehicle.vehicleNo,
            title: vehicle.vehicleNo,
            rideId: vehicle.rideId,
            vehicleId: vehicle.vehicleId,
            latitude: vehicle.vehicleLatitude,
            longitude: vehicle.vehicleLongitude,
          });
          marker.setAnimation(window.google.maps.Animation.BOUNCE);
          marker.setVisible(true);
          setTimeout(function () {
            marker.setAnimation(null);
          }, 1000);

          let infowindow = new window.google.maps.InfoWindow();
          window.google.maps.event.addListener(marker, "click", function () {
            infowindow.setContent(infoContents);
            marker = this;
            this.map.panTo(latLng);
            marker.setAnimation(window.google.maps.Animation.BOUNCE);
            setTimeout(function () {
              marker.setAnimation(null);
            }, 1000);

            let zoomLevel = 17;
            let scale = 400 / 500; //50/500;
            zoomLevel = 16 - Math.log(scale) / Math.log(2);
            this.map.setZoom(zoomLevel);
            infowindow.open(this.map, marker);
          });
          infowindow.addListener("closeclick", () => {
            this.map.panTo(latLng);
            this.map.setZoom(12);
          });
          this.vehicleMarkers.push({ marker: marker });
          bounds.extend(latLng);
          this.map.fitBounds(bounds);
        }
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".drawVehicleMarkers function",
        err
      );
    }
  };
  clrearVehicleMarker = () => {
    try {
      for (let i = 0; i < this.vehicleMarkers.length; i++) {
        this.vehicleMarkers[i].marker.setMap(null);
      }
      this.vehicleMarkers = new Array();
    } catch (error) {}
  };
  getMarkerIconUrl = (hostStatus, course) => {
    let _course = course - (course % 5);
    let folderAndiconName = "Car";
    return (
      "../assets/img/direction/" +
      folderAndiconName +
      "/" +
      folderAndiconName +
      "_" +
      this.getColorByHostStatus(hostStatus) +
      ("_" + _course) +
      ".png?v=1.6"
    );
  };
  getColorByHostStatus = (hostStatus) => {
    let color = "";
    if (hostStatus === 0) {
      color = "orange";
    } else if (hostStatus === 1) {
      color = "green";
    } else if (hostStatus === 2) {
      color = "red";
    } else if (hostStatus === 3) {
      color = "orange";
    } else if (hostStatus === 4) {
      color = "blue";
    }
    return color;
  };

  setMarkerLableContent = (item) =>
    `<div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <i className="fas fa-car" />Vehicle:&nbsp;&nbsp;${item.vehicleNo}
      </div>
      <div>
        <i className="fas fa-tachometer-alt"/>Speed:&nbsp;&nbsp;${item.vehicleSpeed.toFixed(
          1
        )} Km
      </div>
      <div>  <span className="text-success text-sm-right">Crew:&nbsp;&nbsp;${
        item.paxName
      }</span></div>
       <div>  <span className="text-success text-sm-right">Employee No:&nbsp;&nbsp;${
         item.employeeNo
       }</span></div>
    </div>`;
  setMarkerInfoContent = (item) => {
    let gpsDateTime = this.getDatetimeForamted(item.gpsDateTime);
    let pickupDateTime = this.getDatetimeForamted(item.pickupDateTime);
    return `<div>
        <table border="0" width="100%">
          <tr>
            <td colspan="2">
              <b className="text-muted">
                <i className="fas fa-chalkboard"></i>Crew Name
              </b>
              <br />
              <label id="lblPaxName">${item.paxName}</label>
            </td>
          </tr>
          <tr>
            <td>
              <b>
                <i className="fas fa-car"></i> Vehicle
              </b>
              <br />
              <span>${item.vehicleNo}</span>
            </td>
            <td width="50%">
              <strong className="text-muted">
                <i className="fas fa-user"></i> Driver
              </strong>
              <br />
              <label>${item.driverName}</label>
              <label className="badge badge-success" id="lblStatus">
                ${item.tripStatusDescription}
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <strong className="text-muted">
                <i className="fas fa-clock"></i> Last GPS Time
              </strong>
              <br />
              <label>${gpsDateTime}</label>
            </td>
            <td>
              <strong className="text-muted">
                <i className="fas fa-clock"></i> Pickup Time
              </strong>
              <br />
              <label>${pickupDateTime}</label>
            </td>
          </tr>
          <tr>
            <td align="top">
              <strong className="text-muted">
                <i className="fas fa-map-marker-alt"></i> Pick-up
              </strong>
              <br />
              <label>${item.pickupLocation}</label>
            </td>
            <td align="top">
              <strong className="text-muted">
                <i className="fas fa-map-marker-alt"></i> Dropoff
              </strong>
              <br />
              <label>${item.dropoffLocation}</label>
            </td>
          </tr>
          <tr>
            <td>
              <strong className="text-muted">
                <i className="fas fa-hourglass-start"></i>
                <span id="lblEtaEtdName">Driver Mobile</span>
              </strong>
              <br />
              <span id="lblEtaEtd">${item.driverMoblieNo}</span>
            </td>
            <td>
              <strong className="text-muted">
                <i className="fas fa-tachometer-alt"></i> Speed
              </strong>
              <br />
              <label id="lblSpeed">${item.vehicleSpeed.toFixed(1)} Km</label>
            </td>
          </tr>
        </table>
      </div>`;
  };
  trackingListItemTemplate = (item) => (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <div>
        <div className="divider text-hr">
          <span className="flight">
            <i
              className={`fas fa-${
                item.activityTypeId === 2
                  ? "map-marker-alt fa-xs"
                  : "plane fa-rotate-270"
              }`}
            ></i>
            &nbsp;{item.activityDisplay}
          </span>
        </div>
        <div className="tracking-info">
          <div className="vehicle">
            <span>
              <i className="fas fa-car circle-icon"></i>
            </span>
          </div>
          <div className="driver">
            <div>
              <strong>{item.vehicleNo}</strong>
              {(item.vehicleLatitude === 0 || item.vehicleLongitude === 0) && (
                <div className="text-danger text-small">
                  Gps location not found
                </div>
              )}
            </div>
            <div className="text-muted">{item.driverName}</div>
            <div className="pickup">
              <div>
                <i className="far fa-clock"></i>
                {item.gpsDateTime
                  ? moment(item.gpsDateTime).format(
                      DateFormat.MomentDisplayDateTimeAMPMFullFormat
                    )
                  : ""}
              </div>
              <div>
                <b>{item.tripStatusDescription}</b>
              </div>
            </div>
            <div>{item.paxName}</div>
          </div>
        </div>
      </div>
    </div>
  );
  handleOnSelectVehicle = (e) => {
    try {
      if (this.vehicleMarkers !== null) {
        if (e.itemData.vehicleLatitude > 0 && e.itemData.vehicleLongitude > 0) {
          for (let i = 0; i < this.vehicleMarkers.length; i++) {
            if (this.vehicleMarkers[i].marker.rideId === e.itemData.rideId) {
              let marker = this.vehicleMarkers[i].marker;
              marker.setAnimation(window.google.maps.Animation.BOUNCE);
              marker.setVisible(true);
              this.setZoom(
                marker.latitude,
                marker.longitude,
                this.state.radius
              );
              setTimeout(function () {
                marker.setAnimation(null);
              }, 1000);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <>
        <div className="card mb-2">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h6 className="text-primary">
                  Note: Tracking will display only when vehicle(s) are on JOB.
                </h6>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div className="form-group">
                  <label>Airport(s)</label>
                  <SelectBox
                    dataSource={this.state.airportDropdownDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="All Airports"
                    value={this.state.airportCode}
                    displayExpr="airportName"
                    valueExpr="airportCode"
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={(e) => {
                      try {
                        let mapCenter = this.state.map;
                        let airportCode = e.selectedItem?.airportCode ?? "";
                        let latitude =
                          e.selectedItem?.latitude ?? mapCenter.center.lat;
                        let longitude =
                          e.selectedItem?.longitude ?? mapCenter.center.lng;
                        this.setState({
                          airportCode: airportCode,
                          map: {
                            center: {
                              lat: latitude,
                              lng: longitude,
                              zoom: 8,
                            },
                          },
                        });
                      } catch (error) {}
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div className="form-group">
                  <label>Transport Vendor(s)</label>
                  <SelectBox
                    dataSource={this.state.transporterDropdownDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="All Vendors"
                    value={this.state.transporterId}
                    displayExpr="name"
                    valueExpr="id"
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onValueChanged={(e) => {
                      this.setState((prev) => ({
                        ...prev,
                        transporterId: e.value ?? 0,
                      }));
                    }}
                  />
                </div>
              </div>
              <div
                className="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                style={{ marginTop: "10px" }}
              >
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={async () => {
                      await this.getTrackingData(
                        this.state.transporterId,
                        this.state.airportCode
                      );
                    }}
                  >
                    <i
                      className={`fas fa-${
                        this.state.isSearch ? "spinner fa-spin" : "search"
                      }`}
                    />{" "}
                    Search
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      try {
                        clearInterval(this.trackingRefreshInterval);
                        this.clrearVehicleMarker();
                        this.vehicleMarkers = [];
                        this.trackingRefreshInterval = null;
                        this.setState((prev) => ({
                          ...prev,
                          transporterId: 0,
                          airportCode: "",
                          trackingLst: [],
                        }));
                        this.map.setZoom(this.state.map.zoom);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body-map">
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 pr-0">
                <div className="form-group">
                  <List
                    style={{ height: `75.5vh` }}
                    dataSource={
                      new DataSource({
                        store: this.state?.trackingLst ?? [],
                        sort: [
                          "Position",
                          { selector: "vehicleNo", desc: true },
                        ],
                        paginate: true,
                        pageSize: 10,
                      })
                    }
                    keyExpr="rideId"
                    displayExpr="vehicleNo"
                    itemRender={this.trackingListItemTemplate}
                    searchEnabled={true}
                    searchExpr={[
                      "vehicleNo",
                      "rideId",
                      "activityDisplay",
                      "driverName",
                      "gpsDateTime",
                      "paxName",
                      "employeeNo",
                    ]}
                    searchMode="contains"
                    pageLoadMode="scrollBottom"
                    selectionMode="single" // to show the selected color
                    //showSelectionControls={true} // to hide readion and checkbox
                    selectByClick={true}
                    indicateLoading={true}
                    onItemClick={this.handleOnSelectVehicle}
                  />
                </div>
              </div>

              <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 pl-0">
                <div
                  ref={this.mapRef}
                  id="map"
                  style={{ height: `75.5vh`, width: `99%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={{ of: "#root" }}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </>
    );
  }
}
